import React, { useState, useEffect, useCallback, useRef } from "react";
import Loader from "../../components/Loader";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
    Icon,
    Box, Button, TextField, IconButton, InputAdornment, Typography,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Grid, Tabs, Tab, Card, CardMedia, CardContent, CardActions, useTheme, Dialog,
    DialogTitle, DialogContent, DialogActions, MenuItem, Tooltip,
    CircularProgress,
    Link
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { Search, List, GridView, StarOutline, Star, Delete, Cancel } from "@mui/icons-material";
import { withTranslation, useTranslation } from "react-i18next";
import { GetDashboardListSearchUrl, InsertUpdateDashboardFavUrl, DeleteActionUrl, GetShareDashboardUrl, dashboardRoleActionID, InsertShareDashboardurl, SearchUserAndADGroupUrl, SendMailNotificationUrl, GetUserShareAccessUrl } from "../../utils/constants";
import CommonPagination from "../../components/CommonPagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { axiosDelete, axiosGet, axiosPost } from "../../utils/Axios";
import { useToast } from '../../components/toast';
import { useFillList } from "../../components/fillList";
import _ from 'lodash';
import { HeaderBlock } from "@colliers/colliers-b2c";
import { hasInactiveClientEmails } from "./inactiveClientHelper";

const DashboardList = (_props) => {
    const getNextYearDate = () => {
        const today = new Date();
        const nextYear = new Date(today.setFullYear(today.getFullYear() + 1));
        return nextYear.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };
    const theme = useTheme();
    const navigate = useNavigate();
    //toast
    const { ToastComponent, showToast } = useToast();
    //loader
    const [isLoading, setIsLoading] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [isloadRender, setIsloadRender] = useState(false);

    //pop
    const [isFavModal, setFavModal] = useState(false);
    const [isDeleteModal, setDeleteModal] = useState(false);
    const [shareModal, setShareModal] = useState(false);
    //state
    const [dashboardID, setDashboardID] = useState('');
    const [ServicePrincipalID] = useState('');
    const setDashboardGroupID = useState({})[1];
    const setDeleteUserID = useState({})[1];

    const [isFav, setIsFav] = useState(false);
    const [dashboardList, setDashboardList] = useState([]);
    const [canShareClient, setCanShareClient] = useState(false);
    const [canShareColliers, setCanShareColliers] = useState(false);
    const [dashboardGroupList, setdashboardGroupList] = useState([]);
    const [dashboardName, setDashboardName] = useState("");
    const [viewType, setViewType] = useState("card");
    const [tabValue, setTabValue] = useState(0);
    const [roleID] = useState(JSON.parse(localStorage.getItem("userInfo"))?.roleID);
    // Calculate Paginated Records
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredDashboards, setFilteredDashboards] = useState(dashboardList)
    //share modal
    const [isRLS, setIsRLS] = useState(true)
    const [isRemoveUserModal, setRemoveUserModal] = useState(false);
    const [removeUserIndex, setRemoveUserIndex] = useState('');
    const [GroupnUserListErr, setGroupnUserListErr] = useState("");
    const [inputValue, setInputValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState('');
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [isUserLoading, setIsUserLoading] = useState(false);
    const [userCurrentPage, setUserCurrentPage] = useState(1);
    const searchAbortControllerRef = useRef(null);
    const searchRequestIdRef = useRef(0);

    const setErrors = useState({})[1];

    //invite
    const [isInvite, setIsInvite] = useState(false);
    const [inviteEmail, setInviteEmail] = useState('');
    const [inviteValidUntil, setInviteValidUntil] = useState(getNextYearDate());
    const [inviteRls, setInviteRls] = useState('');
    const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
    const [pendingInviteUsers, setPendingInviteUsers] = useState([]);
    //fillList
    const [DashboardUserData, setDashboardUserData] = useState([]);
    const [DashboardRoleFillList, setDashboardRoleFillList] = useState([]);
    const roleFillList = useFillList(dashboardRoleActionID, "", ""); // Action ID 4
    const [GroupnUserList, setGroupnUserList] = useState([]);
    //pagination
    //cards

    //list
    const listItemsPerPage = 10;
    const totalItems = filteredDashboards?.length;
    const startIndex = (currentPage - 1) * listItemsPerPage;
    const paginatedDashboards = filteredDashboards?.slice(startIndex, startIndex + listItemsPerPage);
    const userItemsPerPage = 10;
    const totalUserItems = DashboardUserData?.length || 0;
    const userStartIndex = (userCurrentPage - 1) * userItemsPerPage;
    const paginatedUserData = DashboardUserData?.slice(userStartIndex, userStartIndex + userItemsPerPage) || [];
    //translations
    const { t } = useTranslation();
    //common
    const TAction = t("common.Action");
    const TnoRecordFound = t("common.noRecordFound");
    const TnoUserFound = t("common.noUserFound");
    const Tcancel = t("common.Cancel");
    const Tadd = t("common.Add");
    const TDashboard = t("common.Dashboard");
    const TInvite = t("common.Invite");
    const Tshare = t("common.Share");
    const Tdelete = t("common.Delete");
    const Tyes = t("common.yes");
    const TreactivateAccount = t("clientPage.reactivateAccount");
    const TreactivateClientConfirmation = t("clientPage.reactivateClientConfirmation");
    //list
    const TmyDashboards = t("dashboardList.myDashboards");
    const TaddDashboardButton = t("dashboardList.addDashboardButton");
    const TsearchForDashboard = t("dashboardList.searchForDashboard");
    const Tclient = t("dashboardList.dashboardTable.client");
    const TSharedBy = t("dashboardList.dashboardTable.SharedBy");
    const TSharedDate = t("dashboardList.dashboardTable.SharedDate");
    const TCreatedBy = t("common.createdBy");
    const TCreatedDate = t("common.createdDate");
    const TValidUntil = t("dashboardList.dashboardTable.ValidUntil");
    //dashboardShare
    const TgroupNusers = t("dashboardAddUpdate.dashboardUdt.groupNusers");
    const TinviteUsers = t("dashboardAddUpdate.dashboardUdt.inviteUsers");
    const TemailUdt = t("dashboardAddUpdate.dashboardUdt.emailUdt");
    const TroleUdt = t("dashboardAddUpdate.dashboardUdt.roleUdt");
    const TguestEmailUdt = t("dashboardAddUpdate.dashboardUdt.guestEmailUdt");
    const TguestEmailNoteUdt = t("dashboardAddUpdate.dashboardUdt.guestEmailNoteUdt");
    const TAddAsUdt = t("dashboardAddUpdate.dashboardUdt.AddAsUdt");
    const TvalidUntilUdt = t("dashboardList.dashboardTable.ValidUntil");
    const TRLS = t("dashboardAddUpdate.dashboardFields.RLS");

    useEffect(() => {
        console.log(roleID);
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) {
            navigate("/login/root-data");
            return;
        }
        getDashboardList();
        GetUserShareAccess();
    }, []);

    useEffect(() => {
        if (roleFillList.data) {
            setDashboardRoleFillList(roleFillList.data);
        }
    }, [roleFillList.data]);

    useEffect(() => {
        if (debouncedValue) {
            SearchUserAndADGroup(debouncedValue);
        }
    }, [debouncedValue]);

    useEffect(() => {
        return () => {
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
        };
    }, []);

    const getDashboardList = async (searchTerm = "") => {
        const endpoint = `?dashboardName=${searchTerm}`
        isloadRender ? setIsLoading(false) : setIsLoading(true)
        try {
            const response = await axiosGet(`${GetDashboardListSearchUrl}${endpoint}`);
            console.log(response);
            if (response) {
                console.log(response)
                setdashboardGroupList(response.dashboardGroupList);
                setDashboardList(response.dashboardList);
                setFilteredDashboards(response.dashboardList);
                setCurrentPage(1)
                setTimeout(() => {
                    setIsLoading(false)
                    setIsloadRender(false)
                }, 500);
            } else {
                setIsLoading(false)
                setIsloadRender(false)
                console.error("Failed to fetch dashboards: No data found.");
            }
        } catch (error) {
            setIsloadRender(false)
            setIsLoading(false)
            console.error("Error fetching dashboards:", error);
        }
    };

    const handleSearch = (query) => {
        setIsloadRender(true)
        if (query.length >= 3) {
            let filtered = dashboardList.filter((dashboard) =>
                dashboard.title.toLowerCase().includes(query.toLowerCase())
            );

            if (filtered.length === 0) {
                filtered = dashboardList.filter((dashboard) =>
                    dashboard.clientName.toLowerCase().includes(query.toLowerCase())
                );
            }

            setFilteredDashboards(filtered);
            console.log("Filtered Dashboards:", filtered);
            setIsloadRender(true)
        } else {
            getDashboardList();
        }
    };
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };
    const debouncedSearch = debounce(handleSearch, 200);
    const handleChange = (e) => {
        const inputValue = e.target.value;
        setDashboardName(inputValue);
        debouncedSearch(inputValue);
    };


    const toggleFavourite = (dashboardID, isFav, dashboardName) => {
        if (isFavModal) {
            setFavModal(false);
            setDashboardID('');
            setIsFav(false);
            setDashboardName('');
        } else {
            setFavModal(true);
            setDashboardID(dashboardID);
            setIsFav(isFav);
            setDashboardName(dashboardName);
        }
    };

    const submitFavourite = async (dashboardID, isFav) => {
        const endpoint = `?dashboardID=${dashboardID}&isFav=${isFav}`;
        try {
            const response = await axiosPost(`${InsertUpdateDashboardFavUrl}${endpoint}`);
            if (response) {
                showToast('success', 'Successfully updated favourite status!');
                setIsloadRender(true)
                getDashboardList();
                setDeleteModal(false);
                setDashboardID('');
                setDashboardName('');
                setDashboardGroupID('');
                setDeleteUserID('');
            } else {
                showToast('error', 'Failed to update favourite status: No data found.');
                console.error("Failed to fetch dashboards: No data found.");
            }
        } catch (error) {
            showToast('error', 'Error updating favourite status.');
            console.error("Error fetching dashboards:", error);
        } finally {
            setFavModal(false); // Close the modal after the action
        }
    };

    const toggleDeleteModal = (dashboardID, dashboardName, dashboardGroupID, _deleteUserID) => {
        if (isDeleteModal) {
            setDeleteModal(false);
            setDashboardID('');
            setDashboardName('');
            setDashboardGroupID('');
            setDeleteUserID('')
        } else {
            setDeleteModal(true);
            setDashboardID(dashboardID);
            setDashboardName(dashboardName);
            setDashboardGroupID(dashboardGroupID);
            setDeleteUserID(1)
        }
    };
    const toggleShareModal = (dashboardID, isRLS) => {
        if (shareModal) {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
            searchRequestIdRef.current += 1;
            setShareModal(false);
            setDashboardID('');
            setIsRLS(0)
            setGroupnUserList([])
            setInputValue('')
            setDebouncedValue('')
            setDashboardUserData([])
            setUserCurrentPage(1)
            setIsUserLoading(false)
            setRemoveUserIndex('')
            setInviteEmail('')
            setInviteValidUntil('')
            setInviteRls('')
            setIsInvite(false)
            setIsReactivateModalOpen(false);
            setPendingInviteUsers([]);
        } else {
            setShareModal(true);
            setDashboardID(dashboardID);
            setIsRLS(isRLS)
            setInputValue('')
            setDebouncedValue('')
            setDashboardUserData([])
            setUserCurrentPage(1)
            // GetDashboardUsers()
            GetShareDashboard(dashboardID)
        }
    };
    const formatValidUntilNew = (validUntil) => {
        return validUntil ? moment(validUntil).format('DD-MM-YYYY') : null;
    };
    const handleShare = async () => {

        const invalidUsers = GroupnUserList.filter(user => {
            const validUntilDate = user.validUntil;
            return !validUntilDate || isNaN(Date.parse(validUntilDate));
        });

        if (invalidUsers.length > 0) {
            showToast('error', 'Some users have invalid or missing validUntil dates.');
            return;
        }
        const endpoint = `?dashboardID=${dashboardID}`;
        const updatedGroupnUserList = GroupnUserList.map(user => ({
            adGroup: user.adGroup,
            adGroupID: user.adGroupID !== "" ? user.adGroupID : 0,
            azureGroupID: user.azureGroupID !== "" ? user.azureGroupID : 0,
            azureGroup: user.azureGroup,
            dashboardRoleID: user.dashboardRoleID,
            displayName: user.displayName,
            emailAddress: user.emailAddress,
            userID: user.userID !== "" ? user.userID : 0,
            dashboardID: user.dashboardID ? user.dashboardID : dashboardID,
            rlsName: user.dashboardRLS != null ? user.dashboardRLS : '',
            dashboardRole: user.dashboardRole,
            validUntil: formatValidUntilNew(user.validUntil),
            isCreatedBy: user.isCreatedBy,
            isDeleted: user.isDeleted
        }));

        setIsSearchLoading(true);
        try {
            const response = await axiosPost(`${InsertShareDashboardurl}${endpoint}`, updatedGroupnUserList);
            if (response) {
                showToast('success', 'Successfully Shared!');
                getDashboardList();
                setIsSearchLoading(false);
            } else {
                setIsSearchLoading(false);
                console.error("Failed to Share dashboards.");
                showToast('error', 'Failed to Share dashboards: No data found.');
            }
        } catch (error) {
            setIsSearchLoading(false);
            console.error("Error Sharing Dashboard:", error);
            showToast('error', `Error Sharing Dashboard: ${error}`);
        } finally {
            setIsSearchLoading(false);
            setShareModal(false);
        }
    };

    const handleDelete = async (dashboardID) => {

        try {
            const response = await axiosDelete(DeleteActionUrl, { moduleID: 4, valueID: dashboardID.toString() });
            if (response) {
                showToast('success', 'Successfully Deleted!');
                setIsloadRender(true)
                getDashboardList()
                setDeleteModal(false);
                setDashboardID('');
                setDashboardName('');
                setDashboardGroupID('');
                setDeleteUserID('')
            } else {
                showToast('error', 'Failed to fetch user list: No data found.');
            }
        } catch (error) {
            showToast('error', 'Failed to fetch dashboards: No data found.');
        } finally {
            setDeleteModal(false); // Close the modal after the action
        }
    }

    const handleTabClick = (group, index) => {
        if (group.dashboardGroup === "All") {
            setFilteredDashboards(dashboardList);
        } else {
            setFilteredDashboards(dashboardList.filter((item) => item.dashboardGroupID == group.dashboardGroupID));
        }
        setTabValue(index)
        setCurrentPage(1);
    };
    const handleAddClick = () => {
        navigate("/dashboardAdd");
    };
    const navigateUpdate = (dashboardID) => {
        navigate("/dashboardAdd", { state: { dashboardID } });
    }
    const navigateLoadDashboard = (randomCode) => {
        navigate("/loadDashboard", { state: { randomCode } })
    }
    //share modal
    const SearchUserAndADGroup = async (searchUserKeyword) => {
        const trimmedKeyword = searchUserKeyword?.trim() || "";
        if (trimmedKeyword.length < 3) {
            setDashboardUserData([]);
            setUserCurrentPage(1);
            setIsUserLoading(false);
            return;
        }
        if (searchAbortControllerRef.current) {
            searchAbortControllerRef.current.abort();
        }
        const abortController = new AbortController();
        searchAbortControllerRef.current = abortController;
        const requestId = ++searchRequestIdRef.current;

        setIsUserLoading(true);
        setDashboardUserData([]);
        setUserCurrentPage(1);
        try {
            const encodedKeyword = encodeURIComponent(trimmedKeyword);
            const response = await axiosGet(
                `${SearchUserAndADGroupUrl}?keyword=${encodedKeyword}&ServicePrincipalID=${ServicePrincipalID ? ServicePrincipalID : 0}&DashboardID=${dashboardID ? dashboardID : 0}`,
                null,
                { signal: abortController.signal }
            );
            if (requestId !== searchRequestIdRef.current || abortController.signal.aborted) {
                return;
            }
            console.log(response);
            if (Array.isArray(response)) {
                const nextYearDate = getNextYearDate();
                const updatedData = response.map((row) => ({
                    ...row,
                    isAdded: 0,
                    validUntil: nextYearDate
                }));
                setDashboardUserData(updatedData);
            } else {
                setDashboardUserData([]);
                console.error("Failed to search Users: No data found.");
            }
        } catch (error) {
            if (requestId === searchRequestIdRef.current && !abortController.signal.aborted) {
                console.error("Error Search Users:", error);
            }
        } finally {
            if (requestId === searchRequestIdRef.current && !abortController.signal.aborted) {
                setIsUserLoading(false);
            }
        }
    };



    const GetUserShareAccess = async () => {
        try {
            const response = await axiosGet(GetUserShareAccessUrl);
            console.log(response);
            if (response) {
                setCanShareClient(response.canShareClient);
                setCanShareColliers(response.canShareColliers);
            } else {
                console.error("Failed to fetch GetDashboardUsers: No data found.");
            }
        } catch (error) {
            console.error("Error fetching GetDashboardUsers:", error);
        }
    };
    const GetShareDashboard = async (dashboardID) => {
        const endpoint = `?dashboardID=${dashboardID}`
        try {
            const response = await axiosGet(`${GetShareDashboardUrl}${endpoint}`);
            console.log(response);
            if (response) {
                const existingUsers = response.map(user => ({
                    ...user,
                    isDeleted: user.isDeleted !== undefined ? user.isDeleted : false,
                    rlsName: user.dashboardRLS != '' ? user.dashboardRLS : '',
                    isMailView: true,
                }));

                if (Array.isArray(existingUsers) && existingUsers.length) {
                    existingUsers.forEach(user => {
                        user.validUntil && (user.validUntil = moment(user.validUntil, 'DD-MM-YYYY').format('YYYY-MM-DD'));
                    });
                }
                setGroupnUserList(existingUsers);
            } else {
                console.error("Failed to fetch GetDashboardUsers: No data found.");
            }
        } catch (error) {
            console.error("Error fetching GetDashboardUsers:", error);
        }
    };

    //add to group user
    const AddtoGroupUsers = async (user) => {
        console.log('userExist', user);

        if (!isValidUser(user)) {
            showToast('error', 'Please select valid until date');
            return;
        }

        const newUser = createNewUser(user);
        const existingUser = findExistingUser(newUser.emailAddress);

        if (existingUser) {
            handleExistingUser(existingUser);
        } else if (newUser.dashboardRoleID === 2 && newUser.emailAddress) {
            await checkInactiveAndAddUsers([newUser.emailAddress], [newUser]);
        } else {
            addUserToGroup(newUser);
        }

        setGroupnUserListErr('');
    };

    // Helper function to check if user is valid
    const isValidUser = (user) => user.validUntil && user.validUntil.trim() !== '';

    // Helper function to create a new user object
    const createNewUser = (user) => ({
        displayName: user.displayName || user.firstName,
        emailAddress: user.userPrincipalName || user.email,
        userID: user.userID || '',
        validUntil: user.validUntil,
        rlsName: '',
        azureGroupID: '',
        azureGroupName: '',
        dashboardRoleID: user.email && user.email.includes('@colliers') ? 4 : 2,
        adGroupID: '',
        isDeleted: false
    });

    // Helper function to find an existing user
    const findExistingUser = (email) => {
        return GroupnUserList.find(existingUser =>
            existingUser.emailAddress.toLowerCase() === email.toLowerCase()
        );
    };

    // Helper function to handle existing user
    const handleExistingUser = (existingUser) => {
        if (existingUser.isDeleted) {
            setGroupnUserList(prevList =>
                prevList.map(user =>
                    user.emailAddress.toLowerCase() === existingUser.emailAddress.toLowerCase()
                        ? { ...user, isDeleted: false }
                        : user
                )
            );
            showToast('success', 'User Added Successfully');
        } else {
            showToast('success', 'User Already Exists');
        }
    };

    // Helper function to add a new user
    const addUserToGroup = (newUser) => {
        setGroupnUserList(prevList => [...prevList, newUser]);
        showToast('success', 'User Added Successfully');
    };

    const inviteSubmit = () => {
        console.log(inviteValidUntil, inviteRls, inviteEmail, 'inviteSubmit');

        if (!validateInputs(inviteEmail, inviteValidUntil, inviteRls)) return;

        const emails = extractEmails(inviteEmail);
        if (!validateEmailFormat(emails)) return;

        processNewUsers(emails);
    };

    // **Helper Function: Validate Input Fields**
    const validateInputs = (email, validUntil, rls) => {
        if (!email.trim()) return showToast("error", "Kindly Enter Email Address"), false;
        if (!validUntil.trim()) return showToast("error", "Kindly Enter Valid Until Date"), false;
        if (isRLS == 1 && !rls.trim()) return showToast("error", "Kindly Enter Row Level Security Name"), false;
        return true;
    };

    // **Helper Function: Extract Emails from Input**
    const extractEmails = (emailInput) => {
        return emailInput
            .split(',')
            .map(email => email.trim())
            .filter(email => email);
    };

    // **Helper Function: Validate Email Format & Duplicates**
    const validateEmailFormat = (emails) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const duplicateEmails = emails.filter((email, index) => emails.indexOf(email) !== index);
        if (duplicateEmails.length) {
            showToast("error", `Duplicate emails found: ${[...new Set(duplicateEmails)].join(', ')}`);
            return false;
        }

        const invalidEmails = emails.filter(email => !emailRegex.test(email));
        if (invalidEmails.length) {
            showToast("error", `Invalid emails: ${invalidEmails.join(', ')}`);
            return false;
        }

        return true;
    };

    // **Helper Function: Process New Users**
    const processNewUsers = (emails) => {
        const newUsers = emails.map(email => ({
            userID: "",
            azureGroupID: "",
            azureGroupName: "",
            emailAddress: email,
            validUntil: inviteValidUntil,
            dashboardRoleID: email.includes('@colliers') ? 4 : 2,
            dashboardRLS: inviteRls,
            adGroupID: "",
            isDeleted: false
        }));

        checkInactiveAndAddUsers(emails, newUsers);
    };

    const checkInactiveAndAddUsers = async (emails, newUsers) => {
        if (await hasInactiveClientEmails(emails)) {
            setPendingInviteUsers(newUsers);
            setIsReactivateModalOpen(true);
            return;
        }
        addUsersToGroup(newUsers);
    };

    const handleConfirmReactivateInvite = () => {
        if (pendingInviteUsers.length > 0) {
            addUsersToGroup(pendingInviteUsers);
        }
        setPendingInviteUsers([]);
        setIsReactivateModalOpen(false);
    };

    const handleCancelReactivateInvite = () => {
        setPendingInviteUsers([]);
        setIsReactivateModalOpen(false);
    };

    // **Helper Function: Add Users to Group List**
    const addUsersToGroup = (newUsers) => {
        const existingEmails = GroupnUserList.map(user => user.emailAddress);
        const duplicateNewUsers = newUsers.filter(user => existingEmails.includes(user.emailAddress));

        if (duplicateNewUsers.length) {
            handleDuplicateUsers(duplicateNewUsers);
        } else {
            setGroupnUserList(prevList => [...prevList, ...newUsers]);
            showToast("success", "User Added Successfully");
        }

        resetInviteFields();
    };

    // **Helper Function: Handle Duplicate Users**
    const handleDuplicateUsers = (duplicateNewUsers) => {
        duplicateNewUsers.forEach(user => {
            const existingUser = GroupnUserList.find(existing => existing.emailAddress === user.emailAddress);

            if (existingUser && existingUser.isDeleted) {
                existingUser.isDeleted = false;
                showToast('success', 'User Added Successfully');
            } else {
                showToast('info', `User ${user.emailAddress} already added.`);
            }
        });
    };

    // **Helper Function: Reset Invite Fields**
    const resetInviteFields = () => {
        setGroupnUserListErr('');
        setInviteEmail('');
        setInviteRls('');
        setIsInvite(false);
    };

    const handleRemovefromGroupList = (email) => {

        const updatedList = GroupnUserList.map((item, _i) =>
            item.emailAddress === email ? { ...item, isDeleted: true } : item
        );
        setGroupnUserList(updatedList);
        setRemoveUserModal(false);
        setRemoveUserIndex('');
        showToast("success", "User Removed Successfully")
    };
    const toggleRemoveUser = (index) => {
        if (isRemoveUserModal) {
            setRemoveUserModal(false);
            setRemoveUserIndex('')
        } else {
            setRemoveUserIndex(index)
            setRemoveUserModal(true);
        }
    };
    const sendMail = async (dashboardID, userID) => {
        const endpoint = `?dashboardID=${dashboardID}&toUserID=${userID}`;
        setIsSearchLoading(true)
        try {
            const response = await axiosPost(`${SendMailNotificationUrl}${endpoint}`);
            if (response) {
                setIsSearchLoading(false)
                showToast('success', 'Mail Sent Successfully!');
            } else {
                showToast('error', 'Failed to Send Mail.');
                setIsSearchLoading(false)
                console.error("Failed to Send Mail.");
            }
        } catch (error) {
            showToast('error', 'Error Sending Mail.');
            setIsSearchLoading(false)
            console.error("Error Sending Mail:", error);
        }
    }
    const handleChangeSearch = (e) => {
        const rawValue = e.target.value;
        const trimmedValue = rawValue.trim();
        setInputValue(rawValue);
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        if (trimmedValue.length < 3) {
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
            searchRequestIdRef.current += 1;
            setDebouncedValue('');
            setDashboardUserData([]);
            setUserCurrentPage(1);
            setIsUserLoading(false);
            return;
        }
        setTypingTimeout(
            setTimeout(() => {
                setDebouncedValue(trimmedValue);
            }, 350)
        );
    };
    const handleDate = useCallback(
        _.debounce((event) => {

            const today = moment().format('YYYY-MM-DD');
            const selectedDate = moment(event, 'YYYY-MM-DD');

            if (selectedDate.isBefore(today, 'day')) {
                showToast('error', "You can not select past date");
            } else {
                setInviteValidUntil(event);
            }
        }, 300), []);
    const handleValidUntil = async (e, i, _data) => {

        const updatedList = [...DashboardUserData];
        updatedList[i] = {
            ...updatedList[i],
            validUntil: e.target.value
        };


        const today = moment().format('YYYY-MM-DD');
        const selectedDate = moment(e.target.value, 'YYYY-MM-DD');

        if (selectedDate.isBefore(today, 'day')) {

            showToast('error', "You can not select past date");
        } else {

            setDashboardUserData(updatedList);
        }
    }
    const handleValidDateChangeEvent = async (e, index, data) => {
        const updatedList = [...GroupnUserList];
        updatedList[index] = {
            ...updatedList[index],
            validUntil: e.target.value
        };
        const today = moment().format('YYYY-MM-DD');
        const selectedDate = moment(e.target.value, 'YYYY-MM-DD');

        if (selectedDate.isBefore(today, 'day')) {
            setErrors(prev => ({
                ...prev,
                [`${data.userID}-validUntil`]: 'Date cannot be in the past.'
            }));
            showToast('error', "You can not select past date");
        } else {
            setErrors(prev => ({
                ...prev,
                [`${data.userID}-validUntil`]: false
            }));
            setGroupnUserList(updatedList);
        }
    }
    const userAccessRights = JSON.parse(localStorage.getItem("userInfo"))?.userAccessRight;
    const hasAccessRightID1 = userAccessRights?.some(access => access.accessRightID === 1) ?? false;


    const shouldShowTrashIcon = (data) => {
        const isRoleThreeAndCreated = Number(data.dashboardRoleID) === 3 && data.isCreatedBy;
        return (!isRoleThreeAndCreated && !data.isDeleted) || Number(data.dashboardRoleID) !== 3;
    };

    // **Helper function: Show Mail Icon**
    const shouldShowMailIcon = (data) => {
        return Number(data.dashboardRoleID) === 2 && data.isMailView === true;
    };

    const getInviteText = () => (isInvite ? TinviteUsers : `${Tadd} ${TgroupNusers}`);

    const addRemoveFromFav = (dashboard) => (
        dashboard.isFav ? "Remove from Favourites" : "Add to Favourites"
    )

    const favouriteAction = (dashboard) => {
        return dashboard.isFav
            ? toggleFavourite(dashboard.dashboardID, false, dashboard.title)
            : submitFavourite(dashboard.dashboardID, true)
    }
    //render
    return (
        <>
            {isLoading && <Loader />}
            <HeaderBlock left="" title={TmyDashboards} actions={(hasAccessRightID1 ) ? <>
                <Button className="add-dashbaord-btn"
                    variant="outlined"
                    startIcon={<i className="fa fa-plus margin-right-none" />}
                    onClick={handleAddClick}
                >
                    {TaddDashboardButton}
                </Button>
            </> : <></>} leftCenterAlign actionsCenterAlign />
            <Box
                id="main"
                className="dashboardListMain"
            >

                <section className="section page-body">
                    <Box className="container">
                        <Grid container className="" >
                            <Grid item xs={12}>
                                <Box display="flex" alignItems="center" className="margin-bottom-base margin-top-s" justifyContent="space-between">
                                    {/* Left buttons */}
                                    <Box className="dashboardDisplayFlex">
                                        <Button
                                            className={`abc1 bor-radi ${viewType === "list" && "list-grid"}`}
                                            variant={viewType === "list" ? "contained" : "outlined"}
                                            startIcon={<List />}
                                            sx={{

                                                '&.MuiButton-contained': {
                                                    backgroundColor: '#000759',
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: '#000759',
                                                    },
                                                },
                                                '&.MuiButton-outlined': {
                                                    color: '#1976d2',
                                                    borderColor: '#1976d2',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                    },
                                                },
                                            }}
                                            onClick={() => setViewType("list")}
                                        >
                                        </Button>
                                        <Button
                                            className={`abc1 bor-radi ${viewType === "card" && "list-grid"}`}
                                            variant={viewType === "list" ? "outlined" : "contained"}
                                            startIcon={<GridView />}
                                            sx={{

                                                '&.MuiButton-contained': {
                                                    backgroundColor: '#000759',
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: '#000759',
                                                    },
                                                },
                                                '&.MuiButton-outlined': {
                                                    color: '#1976d2',
                                                    borderColor: '#1976d2',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                    },
                                                },
                                            }}
                                            onClick={() => setViewType("card")}
                                        >
                                        </Button>
                                    </Box>

                                    {/* Tabs section */}
                                    <Box>
                                        {dashboardGroupList?.length > 0 && (
                                            <Tabs
                                                className="margin-left-base out-border tabs-width"
                                                value={tabValue}
                                                onChange={(_, index) => handleTabClick(dashboardGroupList[index], index)}
                                                aria-label="navigation tabs"
                                                variant="scrollable"
                                                scrollButtons="auto"
                                                sx={{
                                                    "& .MuiTabs-indicator": {
                                                        display: "none",
                                                    },
                                                    "& .MuiTabs-scrollButtons": {
                                                        display: "flex",
                                                    },

                                                }}
                                            >

                                                {dashboardGroupList.map((data, index) => ( // Limit to showing 4 tabs
                                                    <Tab className="list-grid-btn"
                                                        key={index}
                                                        label={`${data.dashboardGroup} (${data.counts})`}
                                                        value={index}
                                                        onClick={() => handleTabClick(data, index)}
                                                        sx={{

                                                            '&.MuiButton-contained': {
                                                                backgroundColor: '#1976d2',
                                                                color: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: '#115293',
                                                                },
                                                            },
                                                            '&.MuiButton-outlined': {
                                                                color: '#1976d2',
                                                                borderColor: '#1976d2',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                                },
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </Tabs>
                                        )}
                                    </Box>

                                    <Box>
                                        <TextField
                                            sx={{
                                                width: '200px',
                                                "& input::placeholder": {
                                                    fontSize: "14px", // Set placeholder font size
                                                },
                                            }}
                                            className="padding-left-none margin-left-m margin-top-s search_input_font"
                                            variant="outlined"
                                            size="large"
                                            placeholder={TsearchForDashboard}
                                            value={dashboardName}
                                            onChange={handleChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <Search className="dashboard-search-icon" fontSize="14" />
                                                ),
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Grid>

                            {viewType === "list" ? (
                                <>
                                    {isloadRender ? <Loader /> : <>
                                        <TableContainer component={Paper} className="list-height padding-left-base padding-right-base padding-x-base padding-bottom-base padding-top-none shadow-0 border-light border-radius">
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        {roleID != 2 && <TableCell>{Tclient}</TableCell>}
                                                        <TableCell>{TDashboard}</TableCell>
                                                        <TableCell>{roleID == 2 ? TSharedBy : TCreatedBy}</TableCell>
                                                        <TableCell>{roleID == 2 ? TSharedDate : TCreatedDate}</TableCell>
                                                        <TableCell>{TValidUntil}</TableCell>
                                                        <TableCell align="center">{TAction}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {paginatedDashboards?.length > 0 ? (
                                                        paginatedDashboards?.map((dashboard, index) => (
                                                            <TableRow key={index}>
                                                                {roleID != 2 && (
                                                                    <TableCell>
                                                                        {dashboard.clientName}
                                                                    </TableCell>
                                                                )}
                                                                <TableCell> <Link className="list-grid-sty" onClick={() => navigateLoadDashboard(dashboard.randomCode)}>{dashboard.title}</Link></TableCell>
                                                                <TableCell>{roleID == 2 ? dashboard.sharedBy : dashboard.createdBy}</TableCell>
                                                                <TableCell>{roleID == 2 ? dashboard.sharedDate : dashboard.createdDate}</TableCell>
                                                                <TableCell>{moment(dashboard.validUntil, "DD-MM-YYYY").isValid()
                                                                    ? moment(dashboard.validUntil, "DD-MM-YYYY").format("DD MMM YYYY")
                                                                    : ""}</TableCell>
                                                                <TableCell align="center">
                                                                    <Box display="flex" justifyContent="center">
                                                                        <Tooltip title={` ${dashboard.isFav ? "Remove" : "Add"} from Favourites`}>
                                                                            <IconButton
                                                                                className="space-btn"
                                                                                onClick={() => favouriteAction(dashboard)}
                                                                            >
                                                                                {dashboard.isFav ? <Star /> : <StarOutline />}
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {dashboard.canShare && (
                                                                            <Tooltip title="Share">
                                                                                <Button
                                                                                    className="padding-left-s margin-left-s padding-right-xs margin-x-none margin-y-none"
                                                                                    sx={{ margin: 0 }}
                                                                                    onClick={() => toggleShareModal(dashboard.dashboardID, dashboard.isRLS)}
                                                                                >
                                                                                    <Icon className="fa fa-share text-primary font-size-base text-primary" />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        )}
                                                                        {dashboard.canDelete && (
                                                                            <Button className="padding-left-s margin-left-s padding-right-xs margin-x-none margin-y-none" sx={{ margin: '0px !important' }}>
                                                                                <Tooltip title="Remove">
                                                                                    <Icon
                                                                                        className="fa-light fa-trash-can font-size-base text-primary"
                                                                                        onClick={() => toggleDeleteModal(dashboard.dashboardID, dashboard.title, dashboard.dashboardGroupID, dashboard.userID)}
                                                                                    />
                                                                                </Tooltip>
                                                                            </Button>
                                                                        )}
                                                                        {dashboard.canEdit && (
                                                                            <Button className="padding-left-s margin-left-s padding-right-xs margin-x-none margin-y-none" sx={{ margin: '0px !important' }}>
                                                                                <Tooltip title="Edit">
                                                                                    <Icon
                                                                                        className="fa-light fa-pen-to-square font-size-base text-primary"
                                                                                        onClick={() => navigateUpdate(dashboard.dashboardID)}
                                                                                    />
                                                                                </Tooltip>
                                                                            </Button>
                                                                        )}
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))) : (
                                                        <TableCell colSpan={5}>{TnoRecordFound}</TableCell>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <CommonPagination
                                                totalItems={totalItems}
                                                currentPage={currentPage}
                                                onPageChange={setCurrentPage}
                                            />
                                        </TableContainer>
                                    </>}
                                </>

                            ) : (
                                <> {isloadRender ? <Loader /> : <>
                                    <Swiper
                                        modules={[Navigation, Pagination]}
                                        spaceBetween={20}
                                        slidesPerView={4}
                                        navigation
                                        pagination={{ clickable: true }}
                                        breakpoints={{
                                            1024: { slidesPerView: 4 },
                                            768: { slidesPerView: 3 },
                                            480: { slidesPerView: 2 },
                                            0: { slidesPerView: 1 },
                                            }}
                                            className="dashboardListSwiper"
                                        sx={{
                                            "--swiper-navigation-color": theme.palette.primary.main,
                                            "--swiper-pagination-color": theme.palette.primary.main,
                                        }}
                                    >
                                        {filteredDashboards?.length > 0 ? (
                                            filteredDashboards?.map((dashboard, index) => (
                                                <SwiperSlide sx={{ width: "100%" }} key={index}>
                                                    <Card className="cart-view padding-y-s padding-x-base border-radius-soft"
                                                        sx={{
                                                            boxShadow: theme.shadows[3],
                                                            "&:hover": { boxShadow: theme.shadows[6] },
                                                        }}
                                                    >
                                                        <a className="dashboardTextDecNone">
                                                            <CardMedia
                                                                className="single-cart-view border-radius-soft"
                                                                component={dashboard.imagePath ? "img" : "div"}
                                                                image={dashboard.imagePath || undefined}
                                                                alt={dashboard.imagePath ? `${dashboard.clientName} - ${dashboard.dashboardName}` : ""}
                                                            />
                                                            <CardContent>
                                                                <Box className="cart-content-outsite">
                                                                    <Typography
                                                                        variant="h6"
                                                                        component="p"
                                                                        className="font-bold font-size-h6 margin-bottom-xs text-align-left text-primary"
                                                                        sx={{
                                                                            flex: 1,
                                                                            wordWrap: "break-word",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => navigateLoadDashboard(dashboard.randomCode)}
                                                                    >
                                                                        {roleID == 2 ? dashboard.title : `${dashboard.clientName} - ${dashboard.title}`}
                                                                    </Typography>
                                                                    <Tooltip title={addRemoveFromFav(dashboard)}>
                                                                        <IconButton onClick={() => dashboard.isFav
                                                                            ? toggleFavourite(dashboard.dashboardID, false, dashboard.title)
                                                                            : submitFavourite(dashboard.dashboardID, true)}
                                                                        >
                                                                            {dashboard.isFav ? <Star color="primary" sx={{ verticalAlign: "middle" }} />
                                                                                : <StarOutline color="primary" sx={{ verticalAlign: "middle" }} />}
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                                <Typography
                                                                    variant="body2"
                                                                    className="text-neutral-8"
                                                                    color="text.secondary font-size-h6 text-align-left"
                                                                    sx={{ lineHeight: 1.5 }}
                                                                >
                                                                    {TSharedBy} {dashboard.sharedBy}
                                                                    <br />
                                                                    {TValidUntil} {moment(dashboard.validUntil, "DD-MM-YYYY").isValid() ? moment(dashboard.validUntil, "DD-MM-YYYY").format("DD MMM YYYY") : ""}
                                                                </Typography>
                                                            </CardContent>
                                                        </a>
                                                        <CardActions sx={{ mt: 2, justifyContent: "end" }}>
                                                            {/* <Share color="primary" onClick={() => toggleShareModal()} /> */}
                                                            {dashboard.canEdit && (
                                                                <Button className="btn-class shadow-0" onClick={() => navigateUpdate(dashboard.dashboardID)}>
                                                                    <Tooltip title="Edit">
                                                                        <Icon className="fa-light fa-pen-to-square font-size-base text-primary" />
                                                                    </Tooltip>
                                                                </Button>
                                                            )}
                                                            {dashboard.canShare && (
                                                                <Button className="btn-class shadow-0">
                                                                    <Tooltip title="Share">
                                                                        <Icon
                                                                            className="fa fa-share text-primary font-size-base text-primary btn-list"
                                                                            onClick={() => toggleShareModal(dashboard.dashboardID, dashboard.isRLS)}
                                                                        />
                                                                    </Tooltip>
                                                                </Button>
                                                            )}
                                                            {/* <Delete color="primary" className="fa-light fa-trash-can" onClick={() => toggleDeleteModal(dashboard.dashboardID, dashboard.title, dashboard.dashboardGroupID, dashboard.userID)} /> */}
                                                            {dashboard.canDelete && (
                                                                <Button className="padding-right-s btn-class shadow-0">
                                                                    <Tooltip title="Delete">
                                                                        <Icon
                                                                            className="fa-light fa-trash-can font-size-base text-primary btn-list"
                                                                            onClick={() => toggleDeleteModal(dashboard.dashboardID, dashboard.title, dashboard.dashboardGroupID, dashboard.userID)}
                                                                        />
                                                                    </Tooltip>
                                                                </Button>
                                                            )}
                                                        </CardActions>
                                                    </Card>
                                                </SwiperSlide>
                                            ))
                                        ) : (
                                            <SwiperSlide>
                                                <Box className="shadow-m text-align-center full-width border-radius-soft"
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        height: "200px",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h6"
                                                        component="p"
                                                        className="text-primary font-semi-bold"
                                                    >
                                                        {TnoRecordFound}
                                                    </Typography>
                                                </Box>
                                            </SwiperSlide>
                                        )}
                                    </Swiper>
                                </>}
                                </>
                            )}
                            <Dialog
                                open={isFavModal}
                                className="dashboardListDialog"
                            >
                                <DialogTitle className="margin-bottom-none font-size-h3 text-primary text-align-left">
                                    <Typography className="font-semi-bold text-primary margin-bottom-s" variant="h6">
                                        {"Remove Favourite"}
                                    </Typography>
                                </DialogTitle>

                                <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                        Are you sure you want to Remove <strong>{dashboardName}</strong> from Favourite?
                                    </Typography>
                                </DialogContent>

                                <DialogActions className="dialogAction">
                                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={() => toggleFavourite('', '')}
                                    >
                                        Cancel
                                    </Button>
                                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                        variant="contained"
                                        onClick={() => submitFavourite(dashboardID, isFav)}
                                        startIcon={<Delete />}
                                    >
                                        Remove
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isDeleteModal}
                                className="dashboardListDialog"
                            >
                                <DialogTitle>
                                    <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left" variant="h6">
                                        Delete Dashboard - {dashboardName}
                                    </Typography>

                                </DialogTitle>

                                <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                        Are you sure you want to Delete this Dashboard?
                                    </Typography>
                                </DialogContent>

                                <DialogActions className="dialogAction">
                                    <Button className="text-neutral-7 border-size-s border-radius-soft add-dashbaord-btn"
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={() => toggleDeleteModal('', '', '')}
                                    >
                                        Cancel
                                    </Button>
                                    <Button className=" border-size-s border-radius-soft del-pop-btn add-dashbaord-btn"
                                        variant="contained"
                                        onClick={() => handleDelete(dashboardID)}
                                        startIcon={<Delete />}
                                    >
                                        Delete
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={shareModal}
                                className="border-radius-soft padding-base dashboardListDialog1"
                                fullWidth={true}
                                maxWidth={'xl'}
                            >
                                {ToastComponent}
                                <DialogTitle>
                                    <Typography
                                        variant="h6"
                                        className="text-align-center text-primary margin-bottom-xs font-semi-bold"
                                    >
                                        {/* Share Dashboard */}
                                        {Tshare} {TDashboard}
                                    </Typography>
                                </DialogTitle>
                                <DialogContent>
                                    {isSearchLoading ? <Loader /> : <>
                                        <Box sx={{ display: "flex", gap: 3 }}>
                                            {/* Groups & Users Section */}
                                            {/* Left Table */}
                                            <Box className="border-size-s border-light padding-x-xs padding-y-xs shadow-0"
                                                sx={{
                                                    flex: 1,
                                                }}
                                            >
                                                <Typography variant="h6" className="text-align-left box-name-tit font-size-h5 text-primary padding-top-base">
                                                    {TgroupNusers}
                                                </Typography>
                                                <TableContainer className="display-rec-4">
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                {/* <TableCell>{TnameUdt}</TableCell> */}
                                                                <TableCell className="padding-left-none">{TemailUdt}</TableCell>
                                                                <TableCell >{TvalidUntilUdt} <Typography variant="p" sx={{ fontWeight: "bold", color: '#ed1b34' }}>*</Typography></TableCell>
                                                                <TableCell sx={{ width: '125px' }} >{TroleUdt} <Typography variant="p" sx={{ fontWeight: "bold", color: '#ed1b34', width: '8rem' }}>*</Typography></TableCell>
                                                                {isRLS && (
                                                                    <TableCell>
                                                                        {TRLS} <Typography variant="p" sx={{ fontWeight: "bold", color: '#ed1b34' }}>*</Typography>
                                                                    </TableCell>
                                                                )}
                                                                <TableCell>{TAction}</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {GroupnUserList.length > 0 ? (
                                                                GroupnUserList.filter(data => !data.isDeleted).map((data, index) => (
                                                                    <TableRow key={data.emailAddress || index}>
                                                                        <TableCell
                                                                            className="padding-left-xs"
                                                                            sx={{
                                                                                width: "20rem",
                                                                                wordWrap: "break-word",
                                                                                whiteSpace: "normal",
                                                                                wordBreak: "break-word",
                                                                            }}
                                                                        >
                                                                            {data.emailAddress}
                                                                        </TableCell>

                                                                        <TableCell className="padding-top-none margin-top-none">
                                                                            <TextField
                                                                                className="padding-x-none padding-y-none margin-x-none margin-y-none"
                                                                                fullWidth
                                                                                type="date"
                                                                                value={data.validUntil}
                                                                                onChange={(e) => handleValidDateChangeEvent(e, index, data)}
                                                                                required
                                                                                variant="outlined"
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell className="padding-top-none margin-top-none">
                                                                            <TextField
                                                                                className="padding-x-none padding-y-none margin-x-none margin-y-none"
                                                                                select
                                                                                fullWidth
                                                                                required
                                                                                disabled={data.dashboardRoleID === 3 || data.dashboardRoleID === 2}
                                                                                value={data.dashboardRoleID}
                                                                                onChange={(e) => {
                                                                                    const updatedList = [...GroupnUserList];
                                                                                    updatedList[index] = {
                                                                                        ...updatedList[index],
                                                                                        dashboardRoleID: e.target.value,
                                                                                    };
                                                                                    setGroupnUserList(updatedList);
                                                                                }}
                                                                                variant="outlined"
                                                                            >
                                                                                {DashboardRoleFillList.map((role) => (
                                                                                    <MenuItem key={role.code} value={role.code}>
                                                                                        {role.description}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                        </TableCell>

                                                                        {isRLS && (
                                                                            <TableCell className="padding-top-none margin-top-none">
                                                                                <TextField
                                                                                    className="margin-y-none margin-x-none"
                                                                                    sx={{ width: '100px' }}
                                                                                    fullWidth
                                                                                    value={data.dashboardRLS}
                                                                                    onChange={(e) => {
                                                                                        const updatedList = [...GroupnUserList];
                                                                                        updatedList[index] = {
                                                                                            ...updatedList[index],
                                                                                            dashboardRLS: e.target.value,
                                                                                        };
                                                                                        setGroupnUserList(updatedList);
                                                                                    }}
                                                                                    required
                                                                                    variant="outlined"
                                                                                />
                                                                            </TableCell>
                                                                        )}

                                                                        <TableCell className="padding-top-none margin-top-none">
                                                                            {shouldShowTrashIcon(data) && (
                                                                                <Icon
                                                                                    className="fa-light fa-trash-can font-size-base margin-right-s text-primary btn-list"
                                                                                    onClick={() => toggleRemoveUser(data.emailAddress)}
                                                                                />
                                                                            )}

                                                                            {shouldShowMailIcon(data) && (
                                                                                <Icon
                                                                                    className="fa-light fa-envelope padding-top-m font-size-base text-danger"
                                                                                    onClick={() => sendMail(dashboardID, data.userID)}
                                                                                />
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))
                                                            ) : (
                                                                <TableRow>
                                                                    <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                                                                        {TnoUserFound}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <Typography defaultValue="Error" variant="p">
                                                    {GroupnUserListErr}
                                                </Typography>
                                            </Box>

                                            {/* Add Groups & Users */}
                                            <Box className="border-size-s border-light padding-x-xs padding-y-xs margin-y-xs margin-y-xs shadow-0"
                                                sx={{
                                                    flex: 1,
                                                }}
                                            >
                                                <Box className="padding-x-xs padding-y-xs margin-bottom-s shadow-0"
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",

                                                    }}
                                                >
                                                    <Typography className="box-name-tit font-size-h5 text-primary dashboardTextTransformUpper" variant="h6" >
                                                        {getInviteText()}
                                                    </Typography>
                                                    {!isInvite && (
                                                        <Button
                                                            className="padding-right-s padding-left-s text-primary background-primary add-dashbaord-btn"
                                                            variant="outlined"
                                                            disabled={!canShareClient}
                                                            startIcon={<AddIcon />}
                                                            onClick={() => setIsInvite(true)}
                                                        >
                                                            {TinviteUsers}
                                                        </Button>
                                                    )}
                                                </Box>
                                                {isInvite ? <>
                                                    <Box className="shadow-0 width-74" sx={{ display: "flex", gap: 3, mb: 3 }}>
                                                        <TextField
                                                            sx={{
                                                                paddingTop: '10px',
                                                                marginLeft: '6px',
                                                                width: isRLS ? "50%" : "70%"
                                                            }}
                                                            label={TguestEmailUdt}
                                                            onChange={(e) => setInviteEmail(e.target.value)}
                                                            value={inviteEmail}
                                                            fullWidth
                                                            placeholder={TguestEmailNoteUdt}
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            variant="outlined"
                                                        />
                                                        <TextField className="padding-top-s margin-left-s"
                                                            sx={{ width: "20%", }}
                                                            label={TvalidUntilUdt}
                                                            onChange={(e) => handleDate(e.target.value)}
                                                            value={inviteValidUntil}
                                                            fullWidth
                                                            type="date"
                                                            required
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                        {isRLS && (
                                                            <TextField
                                                                className="padding-top-s margin-left-s"
                                                                sx={{ width: "15%" }}
                                                                fullWidth
                                                                onChange={(e) => setInviteRls(e.target.value)}
                                                                value={inviteRls}
                                                                required
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                                label="Row Level Security"
                                                            />
                                                        )}
                                                    </Box>
                                                    <Box className="shadow-0 padding-x-xs padding-bottom-base dialogAction"
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            mt: 3,
                                                        }}
                                                    >
                                                        <Button className="margin-right-base "
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => inviteSubmit()}
                                                        >
                                                            {TInvite}
                                                        </Button>
                                                        <Button
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={() => {
                                                                setIsInvite(false)
                                                                setInviteEmail('')
                                                                setInviteRls('')
                                                            }}
                                                        >
                                                            {Tcancel}
                                                        </Button>
                                                    </Box>
                                                    {console.log("GroupnUserList", GroupnUserList)}
                                                </> : <>
                                                    <TextField
                                                        sx={{ mt: '-9px' }}
                                                        fullWidth
                                                        placeholder="Search for a person or group (Minimum 3 characters)"
                                                        variant="outlined"
                                                        value={inputValue}
                                                        onChange={handleChangeSearch}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SearchIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                    {
                                                        isUserLoading ? (
                                                            <Box
                                                                sx={{
                                                                    top: 0, height: '100%', display: 'flex',
                                                                    zIndex: 9999, justifyContent: 'center', alignItems: 'center'
                                                                }}
                                                            >
                                                                <CircularProgress />
                                                            </Box>
                                                        ) : (
                                                            <>
                                                                <TableContainer component={Paper} sx={{ mt: 3 }} className="display-rec-4">
                                                                    <Table>
                                                                        <TableBody>
                                                                            {paginatedUserData.length ? (
                                                                                paginatedUserData.map((data, i) => (
                                                                                    <TableRow className="border-size-s" key={data.userID || data.userPrincipalName || data.email || `${userStartIndex + i}`} sx={{ borderBottom: "2px solid", }}>
                                                                                        <TableCell className="font-semi-bold">
                                                                                            <TextField
                                                                                                sx={{ paddingTop: '10px', background: 'none' }}
                                                                                                label={data.displayName || data.firstName}
                                                                                                value={data.userPrincipalName || data.email}
                                                                                                fullWidth
                                                                                                disabled
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell className="text-neutral-7">
                                                                                            {/*<TextField*/}
                                                                                            {/*    label={TvalidUntilUdt}*/}
                                                                                            {/*    required*/}
                                                                                            {/*    fullWidth*/}
                                                                                            {/*    type="date"*/}
                                                                                            {/*    value={getNextYearDate()}*/}
                                                                                            {/*/>*/}
                                                                                            <TextField className="text-neutral-7 padding-top-s margin-left-s" sx={{ width: "80%" }}
                                                                                                label={TvalidUntilUdt}
                                                                                                fullWidth
                                                                                                type="date"
                                                                                                value={data.validUntil}
                                                                                                onChange={(e) => handleValidUntil(e, userStartIndex + i, data)}
                                                                                                required
                                                                                                variant="outlined"
                                                                                                InputLabelProps={{
                                                                                                    shrink: true,
                                                                                                }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <Button
                                                                                                className={canShareColliers ? 'share-button' : 'share-button-disabled'}
                                                                                                variant="outlined"
                                                                                                startIcon={canShareColliers && <AddIcon />}
                                                                                                sx={{
                                                                                                    fontWeight: "bold",
                                                                                                    textTransform: "none",
                                                                                                }}
                                                                                                disabled={!canShareColliers}
                                                                                                onClick={(event) => {
                                                                                                    event.persist(); // Call persist to keep the event around
                                                                                                    AddtoGroupUsers(data); // Pass user data to AddtoGroupUsers
                                                                                                }}
                                                                                            >
                                                                                                {TAddAsUdt}
                                                                                            </Button>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))
                                                                            ) : (
                                                                                <TableRow>
                                                                                    <TableCell className="text-align-center text-neutral-7" colSpan={3} align="center" >
                                                                                        {TnoRecordFound}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                                {totalUserItems > userItemsPerPage && (
                                                                    <CommonPagination
                                                                        currentPage={userCurrentPage}
                                                                        totalItems={totalUserItems}
                                                                        itemsPerPage={userItemsPerPage}
                                                                        onPageChange={setUserCurrentPage}
                                                                    />
                                                                )}
                                                            </>
                                                        )
                                                    }
                                                </>}
                                            </Box>
                                        </Box>
                                    </>}
                                </DialogContent>

                                <DialogActions className="dialogAction">
                                    {isSearchLoading ? (
                                        <Loader />
                                    ) : (
                                        <>
                                            <Button
                                                    className="text-primary background-primary border-radius-soft padding-x-s padding-y-s cancel-btn dashboardTextTransformUpper"
                                                variant="outlined"
                                                startIcon={<Cancel />}
                                                onClick={toggleShareModal}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                className="text-primary background-primary border-radius-soft padding-x-s padding-y-s cancel-btn"
                                                variant="contained"
                                                onClick={handleShare}
                                            >
                                                <Icon className="fa fa-share text-primary font-size-base btn-list" /> Share
                                            </Button>
                                        </>
                                    )}
                                </DialogActions>
                            </Dialog>
                            <Dialog className="border-radius-soft padding-y-base padding-x-base text-align-center dashboardListDialog2"
                                open={isRemoveUserModal}
                            >
                                <DialogTitle className="dialogAction">
                                    <Typography className="margin-bottom-none font-size-h3 text-primary text-align-left"
                                        variant="h6"
                                        fontWeight="bold"
                                    >
                                        {"Remove User"}
                                    </Typography>
                                </DialogTitle>

                                <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                        Are you sure you want to Remove User from this Group?
                                    </Typography>
                                </DialogContent>

                                <DialogActions className="dialogAction">
                                    <Button className="text-neutral-7 background-neutral-7 border-radius-soft add-dashbaord-btn dashboardTextTransformNone"
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={() => toggleRemoveUser()}
                                    >
                                        {Tcancel}
                                    </Button>
                                    <Button className="background-neutral-7 text-neutral-0 border-radius-soft add-dashbaord-btn dashboardTextTransformNone"
                                        variant="contained"
                                        onClick={() => handleRemovefromGroupList(removeUserIndex)}
                                        startIcon={<Delete />}
                                    >
                                        {Tdelete}
                                    </Button>
                                </DialogActions >

                            </Dialog>
                            <Dialog
                                open={isReactivateModalOpen}
                                onClose={handleCancelReactivateInvite}
                                className="dashboardListDialog"
                            >
                                <DialogTitle className="dialogAction">
                                    <Typography
                                        className="margin-bottom-none font-size-h3 text-primary text-align-left"
                                        variant="h6"
                                        fontWeight="bold"
                                    >
                                        {TreactivateAccount}
                                    </Typography>
                                </DialogTitle>
                                <DialogContent>
                                    <Typography className="margin-bottom-base text-primary font-size-h5 text-align-left">
                                        {TreactivateClientConfirmation}
                                    </Typography>
                                </DialogContent>
                                <DialogActions className="dialogAction">
                                    <Button
                                        className="text-neutral-7 background-neutral-7 border-radius-soft add-dashbaord-btn dashboardTextTransformNone"
                                        variant="outlined"
                                        startIcon={<Cancel />}
                                        onClick={handleCancelReactivateInvite}
                                    >
                                        {Tcancel}
                                    </Button>
                                    <Button
                                        className="background-neutral-7 text-neutral-0 border-radius-soft add-dashbaord-btn dashboardTextTransformNone"
                                        variant="contained"
                                        onClick={handleConfirmReactivateInvite}
                                    >
                                        {Tyes}
                                    </Button>
                                </DialogActions>

                            </Dialog>
                        </Grid>
                    </Box>

                </section>
            </Box>
            {ToastComponent}
        </>
    );
};

export default withTranslation()(DashboardList);
